import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import AssignedDealer from '../../../../../components/customElements/RequestDataAccordions/AssignedDealer'
import { openModalFn } from '../../../../../utils/controllers/ModalController'
import DealerSelect from './utils/DealerSelect'

function AssignToDealerView({ store, massAssign, serviceStore }) {
  let { status, dealer } = store.data || serviceStore?.currentServiceData || {}
  dealer = serviceStore
    ? serviceStore.currentServiceData?.assignDealer
    : store.data?.dealer

  return (
    <>
      <Box
        name={'content'}
        mx={2}
        className={classNames('fx fx-col', css({ flex: '1 1 auto' }))}
      >
        <Box mx={-2}>
          {!!status && !massAssign && (
            <AssignedDealer
              request={
                serviceStore ? serviceStore.currentServiceData : store.data
              }
              defaultOpenState={true}
            />
          )}
        </Box>
        <DealerSelect massAssign={massAssign} store={store} />
      </Box>

      <Box name={'action'} width={1} mt={2} p={2} pb={3}>
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          onClick={() => {
            if (massAssign) {
              openModalFn['assign-dealer-submit-dialog']({})
            } else {
              store.assignDealer(null, serviceStore?.updateOrders)
            }
          }}
          disabled={
            !store.newDealer ||
            (store.newDealer === dealer && ![1, 7, 11].includes(status))
          }
        >
          <FormattedMessage id={'Назначить '} />
          {store.dealersStore.getDealer(store.newDealer)?.displayName}
        </Button>
      </Box>
    </>
  )
}

export default observer(AssignToDealerView)
